<template>
    <transition name="fade-transition">
        <div v-if="isActive" class="overlay" :class="{'absolute': this.absolute, 'fixed': this.fixed, 'overlay--active': this.isActive, 'items-center justify-center': center}" >
            <div class="overlay__scrim" :style="{opacity: opacity}" @click="$emit('click')"/>
            <slot/>
        </div>
    </transition>
</template>
<script>
import Toggleable from "../../mixins/Toggleable";

    export default {
        name: "Overlay",

        mixins: [Toggleable],

		emits: ['click'],

        props: {
            absolute: {
                type: Boolean,
                default: false,
            },

            // Whether to center the content of the overlay
            center: {
                type: Boolean,
                default: false,
            },

            fixed: {
                type: Boolean,
                default: false,
            },

            opacity: {
                type: [Number, String],
                default: 0.46,
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.overlay {
  border-radius: inherit;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 100%;
  pointer-events: none;
  margin: 0 !important;
  z-index: 100;
}
.overlay.fixed {
  width: 100vw !important;
  max-width: 100vw !important;
  height: 100vh !important;
  max-height: 100vh !important;
}
.overlay + .overlay {
  z-index: 101;
}

.overlay__content {
  position: relative;
}

.overlay__scrim {
  border-radius: inherit;
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: inherit;
  width: 100%;
  will-change: opacity;
  background-color: #2e3535;
}

.overlay--active {
  pointer-events: auto;
}
</style>